<template>
  <div class="h-full">
    <div class="suporte-cliente-tarefas cli-task-page">
      <div class="nav">
        <a href="/#/console">Console</a>
        <i class="fa fa-chevron-right" />
        <a href="/#/console/tarefas">Tarefas</a>
        <i class="fa fa-chevron-right" />
        <span class="nav-end">Detalhes do caso</span>
      </div>

      <div v-if="!loading && task" class="case">
        <div class="case-header">
          <div class="id">
            Atendimento ID {{task.id}}
            <span class="id-closed" v-if="!isOpened"><i class="fa-duotone fa-check-to-slot"/> Fechado em {{task.closedAt|formatDate}}</span>
            <span class="id-closed bg-green" v-if="task.public"><i class="fa-solid fa-bullhorn" /> Tarefa Pública</span>
            <span class="id-closed transparent" v-if="task.status.code === 'completed'"><check-svg /> Marcado como resolvido</span>
            <span class="id-closed transparent" v-if="task.status.code === 'recused'"><alert-svg /> Solicitação rejeitada</span>
            <span class="id-closed transparent" v-if="task.status.code === 'canceled'"><alert-svg /> Solicitação cancelada</span>
          </div>
          <div class="actions">
            <task-all-persons :task="task" class="m-l" />
            <follow-task :show-legend="true" @followersUpdate="updateFollowers" :task="task"  class="m-l" />
            <u-btn @click="resolver" v-if="isOpened && !isMe" label="Resolver Caso" no-caps color="white" class="m-l text-grey-8 b-radius-3px font-13" />
            <u-btn @click="reabrir" v-if="task.internalStatus === 'closed'" label="Reabrir Caso" no-caps color="blue" class="m-l text-white b-radius-3px font-13" />
          </div>
        </div>
        <div class="case-tab">
          <div class="tab-header">
            <e-row class="full-width">
              <e-col class="m-b-none">Detalhes do atendimento</e-col>
              <e-col class="text-right m-b-none flex items-center justify-end">
                <task-menu-right class="m-r" />
                <task-work />
              </e-col>
            </e-row>
          </div>
          <div class="tab-content starefa-page">
            <e-row class="def full-width" mr>
              <e-col>
                <task-detail title="Assunto">{{ task.description }}</task-detail>
                <e-row mr>
                  <e-col>
                    <task-detail title="Criado">{{ task.createdAt|formatDate }}</task-detail>
                  </e-col>
                  <e-col>
                    <task-detail title="Última atualização">
                      <div v-if="task.dateModified">{{ task.dateModified|formatDate }}</div>
                      <div v-else>-</div>
                    </task-detail>
                  </e-col>
                </e-row>
                <e-row mr>
                  <e-col>
                    <task-detail title="Tipo de requisição">
                      <type-edit/>
                    </task-detail>
                  </e-col>
                  <e-col>
                    <task-detail title="Prioridade">
                      <task-priority />
                    </task-detail>
                  </e-col>
                </e-row>
                <e-row mr>
                  <e-col>
                    <task-detail title="Projeto">
                      <project-edit/>
                    </task-detail>
                  </e-col>
                  <e-col>
                    <task-detail title="Cliente">
                      <cliente-edit/>
                    </task-detail>
                  </e-col>
                </e-row>
              </e-col>
              <e-col>
                <e-row mr>
                  <e-col>
                    <task-detail title="Status">
                      <task-status-btn />
                    </task-detail>
                  </e-col>
                  <e-col>
                    <task-detail title="Fila">
                      <queue-edit/>
                    </task-detail>
                  </e-col>
                </e-row>
                <e-row mr>
                  <e-col>
                    <task-detail title="Posição na Fila">
                      {{ task.queuePosition }}
                    </task-detail>
                  </e-col>
                </e-row>
                <e-row mr>
                  <e-col>
                    <task-detail title="Relator">
                      <author-edit/>
                    </task-detail>
                  </e-col>
                  <e-col>
                    <task-detail title="Responsável principal">
                      <responsavel-edit/>
                    </task-detail>
                  </e-col>
                </e-row>
                <e-row mr>
                  <e-col>
                    <task-detail title="Previsão">
                      <deadline />
                    </task-detail>
                  </e-col>
                  <e-col>
                    <task-detail title="Início do Trabalho">
                      <span v-if="task.startTime">{{ task.startTime.date|formatDateDistance }}</span>
                      <span v-else>-</span>
                    </task-detail>
                  </e-col>
                </e-row>
                <e-row mr>
                  <e-col>
                    <task-detail title="Esforço total previsto">
                      <hour-input v-model="task.expectedHours"/>
                    </task-detail>
                  </e-col>
                  <e-col>
                    <task-detail>
                      <template v-slot:title>
                        <div class="title">
                          Tempo trabalhado
                          <i class="fa-duotone fa-square-question">
                            <u-tooltip :offset="[10,10]">
                              Soma das horas trabalhadas de todos os envolvidos no atendimento
                            </u-tooltip>
                          </i>
                        </div>
                      </template>
                      {{ task.workedHours }}
                    </task-detail>
                  </e-col>
                </e-row>
                <task-detail v-if="task.progress">
                  <template v-slot:title>
                    <div class="title">
                      Progresso
                      <i class="fa-duotone fa-square-question">
                        <u-tooltip :offset="[5,5]">
                          O progresso pode não ser exato ou estar sendo contabilizado pelo responsável pelo atendimento.
                        </u-tooltip>
                      </i>
                    </div>
                  </template>
                  <task-progress />
                </task-detail>
<!--                <task-detail>
                  <template v-slot:title>
                    <div class="title">Teste</div>
                  </template>
                  {{ task.status.name }}
                </task-detail>-->
              </e-col>
            </e-row>
          </div>
        </div>

        <div class="case-tab">
          <div class="tab-header with-btn">
            <div>Caso</div>
            <div>
              <u-btn v-if="!replyTab && isOpened" @click="reply" label="Responder" color="orange-9" class="b-radius-3px font-13" no-caps />
            </div>
          </div>
          <div class="tab-content no-padder">
            <div v-if="replyTab" class="message reply">
              <task-reply :task="task" @update="updateComment" @close="replyTab = false" />
            </div>
            <div v-for="comment in comments" :key="'comment-' + comment.id" class="message">
              <div class="mleft">
                <person-profile :person="comment.author" disable-name />
                <div class="m-t-sm">{{comment.author.name}}</div>
                <div class="m-t-sm">
                  {{comment.createdAt|formatDateDistance}}
                  <div class="font-11 m-t-xs text-grey">{{comment.createdAt|formatDate}}</div>
                </div>
              </div>
              <div class="mright">
                <div class="task-content" v-html="comment.text"></div>
                <task-attachments-files :task="task" :comment="comment" class="m-t"  />
              </div>
            </div>
            <div class="message">
              <div class="mleft">
                <person-profile :person="task.author" disable-name />
                <div class="m-t-sm">{{task.author.name}}</div>
                <div class="m-t-sm">
                  {{task.createdAt|formatDateDistance}}
                  <div class="font-11 m-t-xs text-grey">{{task.createdAt|formatDate}}</div>
                </div>
              </div>
              <div class="mright">
                <div class="task-content" v-html="task.text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="case">
        <sl-loading class="size-18" content="" />
      </div>
    </div>
  </div>
</template>

<script>

import criarTarefa from "components/suporte/cliente/window/criarTarefa"
import SlLoading from "components/layout/components/Loading.vue"
import {find, closeTask, reopenTask} from "@/domain/tarefas/services"
import ERow from "components/layout/components/Row.vue"
import ECol from "components/layout/components/Col.vue"
import TaskDetail from "components/fenaju/components/suporte/tarefas/include/TaskDetail.vue"
import PersonProfile from "components/fenaju/components/suporte/tarefas/include/PersonProfile"
import Deadline from "components/fenaju/components/suporte/tarefas/include/Deadline.vue"
import TaskProgress from "components/fenaju/components/suporte/tarefas/include/Progress.vue"
import FollowTask from "components/sltarefas/components/tarefa/follow-task.vue"
import TaskAllPersons from "components/fenaju/components/suporte/tarefas/include/TaskAllPersons.vue"
import TaskReply from "components/fenaju/components/suporte/tarefas/include/TaskReply.vue"
import TaskAttachmentsFiles from "components/suporte/components/task/include/attachment/files.vue"
import CheckSvg from "@/assets/images/CheckSvg.vue"
import AlertSvg from "@/assets/images/AlertSvg.vue"
import TaskPriority from "components/suporte/components/task/include/Priority.vue"
import TaskStatusBtn from "components/suporte/components/task/include/StatusBtn.vue"
import QueueEdit from "components/suporte/components/task/include/QueueEdit.vue"
import ResponsavelEdit from "components/suporte/components/task/include/ResponsavelEdit.vue"
import AuthorEdit from "components/suporte/components/task/include/AuthorEdit.vue"
import TypeEdit from "components/suporte/components/task/include/TypeEdit.vue"
import HourInput from "components/suporte/components/task/include/HourInput.vue"
import ProjectEdit from "components/suporte/components/task/include/ProjectEdit.vue"
import ClienteEdit from "components/suporte/components/task/include/ClienteEdit.vue"
import TaskMenuRight from "components/suporte/components/task/include/TaskMenuRight.vue";
import TaskWork from "components/suporte/components/task/include/Work.vue";

export default {
  name: "ClienteTarefa",
  provide: function () {
    return {
      taskContainer: this,
      suportePage: this
    }
  },
  mixins: [],
  computed: {
    comments () {
      if (!this.task.comments) {
        return []
      }
      return this.task.comments.slice().sort((a, b) => b.id - a.id)
    },
    me () {
      return this.$uloc.auth.session.user.person
    },
    isMe () {
      return this.task.author.id === this.me
    },
    isOpened () {
      return this.task.internalStatus === 'opened'
    }
  },
  data () {
    return {
      loading: true,
      task: null,
      replyTab: false
    }
  },
  components: {
    TaskWork,
    TaskMenuRight,
    ClienteEdit,
    ProjectEdit,
    HourInput,
    TypeEdit,
    AuthorEdit,
    ResponsavelEdit,
    QueueEdit,
    TaskStatusBtn,
    TaskPriority,
    AlertSvg,
    CheckSvg,
    TaskAttachmentsFiles,
    TaskReply,
    TaskAllPersons,
    FollowTask,
    TaskProgress,
    Deadline,
    PersonProfile,
    TaskDetail,
    ERow,
    ECol,
    SlLoading
  },
  beforeCreate() {
    document.body.classList.add('cli-task-body')
  },
  beforeDestroy() {
    document.body.classList.remove('cli-task-body')
  },
  mounted() {
    const element = document.querySelector('.u-erp-layout-container');
    element.scrollTop = 0;
    this.load()
  },
  watch: {
    '$route.params.id' (v) {
      this.$nextTick(() => {
        this.load()
      })
    }
  },
  methods: {
    load() {
      this.replyTab = false
      this.loading = true
      find(this.$route.params.id)
          .then(response => {
            this.task = response.data
            setTimeout(() => {
              document.title = `Caso #${this.task.id} - Suporte SL`
            }, 2)
            this.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    criarTarefa: criarTarefa,
    open () {
      this.criarTarefa()
    },
    updateFollowers (followers) {
      console.log(followers)
    },
    reply () {
      this.replyTab = true
    },
    updateComment (comment) {
      this.load()
    },
    resolver () {
      this.$uloc.dialog({
        title: 'Resolver caso',
        message: 'Você tem certeza que deseja definir este caso como resolvido?',
        cancel: 'Cancelar',
        ok: 'Sim',
        color: 'primary'
      }).then(() => {
        this.$uloc.loading.show()
        closeTask(this.task)
            .then(response => {
              this.$uloc.loading.hide()
              this.load()
            })
            .catch(error => {
              console.log(error)
              this.alertApiError(error)
              this.$uloc.loading.hide()
            })
      })
    },
    reabrir () {
      this.$uloc.dialog({
        title: 'Reabrir caso',
        message: 'Você tem certeza que deseja reabir este caso?',
        cancel: 'Cancelar',
        ok: 'Sim, reabir',
        color: 'primary'
      }).then(() => {
        this.$uloc.loading.show()
        reopenTask(this.task)
            .then(response => {
              this.$uloc.loading.hide()
              this.load()
            })
            .catch(error => {
              console.log(error)
              this.alertApiError(error)
              this.$uloc.loading.hide()
            })
      })
    }
  },
  meta: {
    title: 'Tarefa'
  }
}
</script>
